var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_7059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5304 6.66504C14.8347 8.15887 14.6178 9.71191 13.9157 11.0652C13.2137 12.4184 12.0689 13.4901 10.6723 14.1014C9.27573 14.7128 7.71177 14.8269 6.24125 14.4247C4.77072 14.0225 3.48252 13.1284 2.59146 11.8914C1.7004 10.6544 1.26034 9.14926 1.34468 7.62706C1.42903 6.10486 2.03266 4.65759 3.05493 3.52658C4.07719 2.39558 5.45629 1.64922 6.96225 1.41196C8.46821 1.17469 10.01 1.46088 11.3305 2.22279",
    stroke: "#10B981",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 7.33154L7.99854 9.33106L14.6636 2.66602",
    stroke: "#10B981",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_7059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.5078dfff7d84007643e9c54e3e28ba78.svg";
export { ForwardRef as ReactComponent };